document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sv-nav-dropdown').forEach((dropdown) => {
    const summary = dropdown.querySelector('summary');
    dropdown.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !dropdown.open) return;
      event.preventDefault();
      dropdown.open = false;
      summary?.focus();
    });
    document.addEventListener('click', (event) => {
      if (dropdown.open && !dropdown.contains(event.target)) dropdown.open = false;
    });
    dropdown.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !dropdown.contains(event.relatedTarget)) dropdown.open = false;
    });
    dropdown.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => { dropdown.open = false; });
    });
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (toggle && mobileNav) {
    const setMenuState = (open) => {
      mobileNav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('sv-menu-open', open);
    };

    toggle.addEventListener('click', () => {
      setMenuState(!mobileNav.classList.contains('is-open'));
    });

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenuState(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setMenuState(false);
        toggle.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1000 && mobileNav.classList.contains('is-open')) setMenuState(false);
    });
  }

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const dotsWrap = carousel.querySelector('[data-carousel-dots]');

    if (!viewport || slides.length < 2) return;

    const dots = slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sv-carousel-dot';
      dot.setAttribute('aria-label', `Show featured product ${index + 1}`);
      dot.addEventListener('click', () => {
        viewport.scrollTo({ left: viewport.clientWidth * index, behavior: 'smooth' });
      });
      dotsWrap?.appendChild(dot);
      return dot;
    });

    const update = () => {
      const index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= slides.length - 1;
    };

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.gallerySrc;
        const srcset = thumb.dataset.gallerySrcset;
        const alt = thumb.dataset.galleryAlt || '';
        if (!src) return;

        main.src = src;
        if (srcset) main.srcset = srcset;
        main.alt = alt;
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const productInfo = select.closest('.sv-product__info');
    const price = productInfo?.querySelector('[data-product-price]');
    const compare = productInfo?.querySelector('[data-product-compare]');

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        const compareValue = option.dataset.compare || '';
        compare.textContent = compareValue;
        compare.classList.toggle('is-hidden', !compareValue);
      }
    });
  });
});
